<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 2 12 12"
    height="18"
    width="18"
  >
    <g
      id="Group_10819"
      data-name="Group 10819"
    >
      <path
        id="Path_1434"
        data-name="Path 1434"
        class="infoIcon0"
        d="M0,0h16v16H0V0z"
      />
      <path
        id="Path_1435"
        data-name="Path 1435"
        class="infoIcon1"
        d="M7.6,6h0.8v0.8H7.6V6z M7.6,7.6h0.8V10H7.6V7.6z M8,4C5.8,4,4,5.8,4,8s1.8,4,4,4s4-1.8,4-4S
        10.2,4,8,4z M8,11.2c-1.8,0-3.2-1.4-3.2-3.2S6.2,4.8,8,4.8s3.2,1.4,3.2,3.2v0C11.2,9.8,9.8,11.2,8,11.2z"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'InfoIcon',
};
</script>

<style type="text/css" lang="scss" scoped>
svg{fill: main.$npGray;}
.infoIcon0 {
  fill: none;
}
</style>
